export const academicZoneACodes = [
  '01',
  '03',
  '07',
  '15',
  '16',
  '17',
  '19',
  '21',
  '23',
  '24',
  '25',
  '26',
  '33',
  '38',
  '39',
  '40',
  '42',
  '43',
  '47',
  '58',
  '63',
  '64',
  '69',
  '70',
  '71',
  '73',
  '74',
  '79',
  '86',
  '87',
  '89',
  '90'
]

export const academicZoneBCodes = [
  '02',
  '04',
  '05',
  '06',
  '08',
  '10',
  '13',
  '14',
  '18',
  '22',
  '27',
  '28',
  '29',
  '35',
  '36',
  '37',
  '41',
  '44',
  '45',
  '49',
  '50',
  '51',
  '52',
  '53',
  '54',
  '55',
  '56',
  '57',
  '59',
  '60',
  '61',
  '62',
  '67',
  '68',
  '72',
  '76',
  '80',
  '83',
  '84',
  '85',
  '88',
  // Corse-du-Sud (2A) and Haute-Corse (2B) share the 20xxx postal prefix
  '20'
]

export const academicZoneCCodes = [
  '09',
  '11',
  '12',
  '30',
  '31',
  '32',
  '34',
  '46',
  '48',
  '65',
  '66',
  '75',
  '77',
  '78',
  '81',
  '82',
  '91',
  '92',
  '93',
  '94',
  '95',
  '971',
  '972',
  '973',
  '974',
  '976'
]

// Residence countries (free text, normalized) whose postal codes carry a french department
export const frenchAcademicZoneCountries = [
  'france',
  'fr',
  'fra',
  'guadeloupe',
  'martinique',
  'guyane',
  'guyane francaise',
  'french guiana',
  'la reunion',
  'reunion',
  'mayotte'
]
